import { render, staticRenderFns } from "./IssueListItem.vue?vue&type=template&id=f197fc92&scoped=true"
import script from "./IssueListItem.vue?vue&type=script&lang=js"
export * from "./IssueListItem.vue?vue&type=script&lang=js"
import style0 from "./IssueListItem.vue?vue&type=style&index=0&id=f197fc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f197fc92",
  null
  
)

export default component.exports